import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '热播排行榜', href: '#ranking' },
    { label: '常见问题', href: '#faq' },
    { label: '关于桃子影院', href: '#about' },
    { label: '用户评价', href: '#comments' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px]">
          <a
            href="#hero"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </span>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-50">
              桃子影院
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-200 hover:text-primary-400 transition-colors rounded-md hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-100 hover:text-primary-400 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}